<template>
  <div class="input-wrapper" :class="{ 'input-password': isPassword }">
    <div style="position: relative;">
      <input
          :type="showPassword ? 'text' : inputType"
          :placeholder="placeholder"
          :value="value"
          :maxlength="maxlength"
          autoComplete="new-password"
          @input="$emit('input', $event.target.value)"
          class="input-field"
      />
      <!-- 密码切换图标 -->
      <span v-if="isPassword" class="toggle-icon" @click="togglePasswordVisibility">
      <img v-if="showPassword" src="@/assets/icon/eye_close.svg" alt="">
      <img v-else src="@/assets/icon/eye_open.svg" alt="">
    </span>
    </div>
    <div class="help" v-if="help">{{ help }}</div>
  </div>
</template>

<script>
export default {
  props: {
    // 输入框类型：text / password
    type: {
      type: String,
      default: 'text',
      validator: value => ['text', 'password'].includes(value)
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    maxlength: {
      type: Number
    },
    help: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  computed: {
    isPassword() {
      return this.type === 'password';
    },
    inputType() {
      return this.isPassword && !this.showPassword ? 'password' : 'text';
    }
  },
  methods: {
    validate() {
      // 验证逻辑
      const isValidate =  this.rules.every(rule => {
        return new RegExp(rule).test(this.value)
      });
      return !isValidate ? {
        isValidate,
        message: this.help || this.$t(`数据格式不正确`)
      } : null
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>
<style lang="less" scoped>
.input-wrapper {
  position: relative;
  display: inline-block;
  flex: 1;
  width: 100%;
  .input-field {
    width: 100%;
    height: 50px;
    padding: 0 16px;
    border: 1px solid #D0D1D2;
    border-radius: 10px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s ease;
    box-sizing: border-box;
    box-shadow: none;
    outline: none;
    -webkit-appearance: none; /* 移除默认外观 */
    appearance: none;
    &:focus {
      border-color: #29D769;
    }
    &::placeholder {
      color: #c2c2c2;
    }
  }

  &.input-password {
    .input-field {
      padding-right: 40px;
    }
  }

  .toggle-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #888;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
  }
}
.help{
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
</style>
